import { render } from "./uk30.vue?vue&type=template&id=5f5c4e18"
import script from "./uk30.vue?vue&type=script&lang=js"
export * from "./uk30.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__